import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import { AxiosError } from 'axios'
import { authService } from '@/services/api'
import { useAuthStore } from '@/stores'
import type { ApiError } from '@/types'

export function useVerifyEmailPending() {
  const { t } = useTranslation('auth')
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const [resendSuccess, setResendSuccess] = useState(false)

  const resendMutation = useMutation({
    mutationFn: authService.resendVerificationEmail,
    onSuccess: () => {
      setResendSuccess(true)
    },
    onError: (error: AxiosError<ApiError>) => {
      console.error('Failed to resend verification email:', error)
    },
  })

  const handleResend = () => {
    setResendSuccess(false)
    resendMutation.mutate()
  }

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return {
    t,
    user,
    isLoading: resendMutation.isPending,
    resendSuccess,
    handleResend,
    handleLogout,
  }
}
